<div class="wrap" *ngIf="!send">
    <h4>Désactivation de l'utilisateur</h4>
    <p>Voulez-vous désactiver l'utilisateur ?</p>

    <div class="btn_action">
        <button class="back" (click)="dialogRef.close()"> Annuler</button>
        <button class="confirm" (click)="ActiveUser()"> Confirmer</button>
    </div>
</div>

<app-validation-animation *ngIf="send" [text]="'L\'utilisateur a bien été désactivé'"></app-validation-animation>